<div class="wrapper flex vcenter">
  <span class="message {{ type }} grow1">{{ message }}</span>
  <a
    class="action"
    href="#"
    role="button"
    (click)="dismiss(); $event.preventDefault()"
    (keydown.enter)="dismiss(); $event.preventDefault()"
  >
    {{ action }}
  </a>
</div>
